"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskType = void 0;
var TaskType;
(function (TaskType) {
    TaskType["calculations"] = "calculations";
    TaskType["productsImport"] = "productsImport";
    TaskType["valuesImport"] = "valuesImport";
    TaskType["brillantsImport"] = "brillantsImport";
    TaskType["artifactsGeneration"] = "artifactsGeneration";
})(TaskType = exports.TaskType || (exports.TaskType = {}));
//# sourceMappingURL=TaskType.js.map